import React from 'react';
import classNames from 'classnames';
import cls from './TaskCardList.module.css';
import { useTaskCardList } from './useTaskCardList';
import { TaskCard } from '../TaskCard/TaskCard';
import { TasksBlockType } from '../../../../../model/taskBoard';
import { EmptyTasks } from '../../../../EmptyTasks/EmptyTasks';

interface TaskCardListProps {
    classes?: string;
    type: TasksBlockType;
}

export const TaskCardList = ({ classes, type }: TaskCardListProps) => {
    const { tasks, filteredTabs } = useTaskCardList(type);

    if (!tasks) return null;

    return (
        <div className={classNames(cls.TaskCardList, [classes])}>
            {!!tasks.length ? (
                tasks.map((taskId: string) => <TaskCard type={type} id={taskId} key={taskId} />)
            ) : (
                <EmptyTasks type={type} filteredTabs={filteredTabs} />
            )}
        </div>
    );
};
